import { Component, OnInit, ViewChild } from '@angular/core';
import { GoogleMap, MapInfoWindow, MapMarker } from '@angular/google-maps';
import { Router } from '@angular/router';
import { FirebaseService } from './core/providers/firebase.service';
import { mapStyle } from './maps';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  searchActive = null;
  @ViewChild(GoogleMap, { static: false }) map: GoogleMap;
  @ViewChild(MapInfoWindow, { static: false }) infoWindow: MapInfoWindow;
  infoContent = '';
  center;
  zoom = 17
  options: google.maps.MapOptions = {
    mapTypeId: 'roadmap',
    zoomControl: true,
    scrollwheel: true,
    disableDoubleClickZoom: false,
    disableDefaultUI: false,
    maxZoom: 30,
    minZoom: 8,
    styles: [
      {
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#2e2d72"//"#1d2c4d" //azul
          }
        ]
      },
      {
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#8ec3b9" //Lineas de calles principales
          }
        ]
      },
      {
        "elementType": "labels.text.stroke",
        "stylers": [
          {
            "color": "#1a3646" //azul 2 PARROQUIAS
          }
        ]
      },
      {
        "featureType": "administrative.country",
        "elementType": "geometry.stroke",
        "stylers": [
          {
            "color": "#22b2ac"//"#4b6878" PRUEBA
          }
        ]
      },
      {
        "featureType": "administrative.land_parcel",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#64779e"
          }
        ]
      },
      {
        "featureType": "administrative.province",
        "elementType": "geometry.stroke",
        "stylers": [
          {
            "color": "#22b2ac"//"#4b6878" PRUEBA
          }
        ]
      },
      {
        "featureType": "landscape.man_made",
        "elementType": "geometry.stroke",
        "stylers": [
          {
            "color": "#334e87"
          }
        ]
      },
      {
        "featureType": "landscape.natural",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#2e2d72"//"#023e58" fondo azul eqpay
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#2e2d72"//"#283d6a" Estadios
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#22b2ac"//"#6f9ba5" letras de los sitios
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "labels.text.stroke",
        "stylers": [
          {
            "color": "#2e2d72"//"#1d2c4d" //azul
          }
        ]
      },
      {
        "featureType": "poi.park",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "color": "#023e58"
          }
        ]
      },
      {
        "featureType": "poi.park",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#3C7680"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#304a7d"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#98a5be"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "labels.text.stroke",
        "stylers": [
          {
            "color": "#2e2d72" //azul
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#2c6675"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
          {
            "color": "#255763"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#b0d5ce"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "labels.text.stroke",
        "stylers": [
          {
            "color": "#023e58"
          }
        ]
      },
      {
        "featureType": "transit",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#98a5be"
          }
        ]
      },
      {
        "featureType": "transit",
        "elementType": "labels.text.stroke",
        "stylers": [
          {
            "color": "#2e2d72" //azul
          }
        ]
      },
      {
        "featureType": "transit.line",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "color": "#283d6a"
          }
        ]
      },
      {
        "featureType": "transit.station",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#3a4762"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#0e1626"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#4e6d70"
          }
        ]
      }
    ]
  }
  markers: any = [];
  dataKiosko: any;
  dataLocals: any;
  optionsMark = { animation: google.maps.Animation.DROP, icon: 'https://firebasestorage.googleapis.com/v0/b/backservicespagos.appspot.com/o/Marcador-Maps%2Ficonsi.png?alt=media&token=2b95b129-ec40-4b0c-84b6-738e3673d1e5' }
  optionsKiosk = { animation: google.maps.Animation.DROP, icon: 'https://firebasestorage.googleapis.com/v0/b/backservicespagos.appspot.com/o/Marcador-Maps%2Fkioskoicon.png?alt=media&token=bd84aae8-6835-4cf3-bbe3-8123b9b23ace' }
  nameCenter: any;
  term;
  values: string;
  idCenter: any;
  photoCenter: any;
  kioskosMarkers = [];
  mipos = [];
  photoMarker: any;

  constructor(
    private router: Router,
    private daService: FirebaseService) { }

  ngOnInit(): void {

    this.findMe();
  }

  findMe() {
    if (navigator.geolocation) {      
      navigator.geolocation.getCurrentPosition((position) => {
        this.showPosition(position);
      });
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  }

  showPosition(position) {
    console.log('carga posición');

    this.center = {
      lat: position.coords.latitude,
      lng: position.coords.longitude
    };

    this.mipos.push({
      position: {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      },
      // label: {
      //   color: 'red',
      //   text: 'Marker label ',
      // },
      // id: '',
      // title: 'ejempplo',
      options: {
        animation: google.maps.Animation.DROP, icon: 'https://firebasestorage.googleapis.com/v0/b/backservicespagos.appspot.com/o/Marcador-Maps%2Fkioskoicon.png?alt=media&token=bd84aae8-6835-4cf3-bbe3-8123b9b23ace'
      },

      
    });

    this.getLocals()
  }

  openInfo(marker: MapMarker, content) {
    this.getProfile(marker, content.id, content.title);

  }

  openInfo2(marker: MapMarker, content) {
    let infoWindowContent =
      `<div id="content"> <span class="spanWindow">
          <img src="" alt="" style="width: 6rem;border-radius: 50%;">
          <h5 >Mi posicion actual</h5></span>
          </div>`;
    this.infoWindow.infoWindow.setContent(
      infoWindowContent
    )
    this.infoWindow.open(marker);
  }


  getLocals() {
    this.markers.length = 0;
    this.markers = [];

    this.daService.getLocals().subscribe((data) => {
      //console.log(data);
      //return
      data['data'].forEach((locals) => {
        
        this.dataLocals = locals;
        this.markers.push({
          position: {
            lat: this.dataLocals.Ubication._latitude,
            lng: this.dataLocals.Ubication._longitude,
          },
          // label: {
          //   color: 'red',
          //   text: 'Marker label ',
          // },
          id: this.dataLocals.userId,
          title: this.dataLocals.name,
          options: {
            animation: google.maps.Animation.DROP, icon: 'https://firebasestorage.googleapis.com/v0/b/eqpayapp.appspot.com/o/iconMapa.png?alt=media&token=530c1468-b545-485d-a30c-64a18c98e3b7'
          },
        })
      })
    }, err => {
      console.log(err)
    });
    if (this.map) {


    }

  }

  getProfile(marker, id, dataMarker?) {

    //console.log(marker); //Todo el objeto
    //console.log(id);
    //console.log(dataMarker); //Nombre del negocio

    let datos = {
      userId: id
    }

    //return
    this.daService.getUserProfile(datos).subscribe((data) => {

      //console.log(data);
      if (marker !== null) {
        let foto = data['negocios'][0]['photo']
        let alias = data['negocios'][0]['alias']
        let direccion = data['negocios'][0]['direccion']
        let movil = data['negocios'][0]['phone']
        let latitud = marker._position['lat']
        let longitud = marker._position['lng']
        //console.log('Muestra la foto');
        //console.log(foto);
        this.photoMarker = (!foto) ? 'https://firebasestorage.googleapis.com/v0/b/eqpayapp.appspot.com/o/eqpay.svg?alt=media&token=ec733e0e-7385-44f1-95d5-461e657a4a04' : foto;
        //console.log(this.photoMarker)
        let infoWindowContent =
          `<div id="content"> <span class="spanWindow">
          <img src="${this.photoMarker}" alt="" style="width: 6rem;border-radius: 50%;">
          <h5 >${dataMarker}</h5></span>
          </div>
          <div style=" margin-top: -13px; ">
          <p class="data-local mb-1"><b>Dirección: </b>${direccion}</p>
          <p class="data-local"><b>Teléfono: </b>${movil}</p>
          </div>
          <a class="btn btn-sm" style="color: #07325b !important;background-color: #ffbd59 !important;border-color: #ffbd59 !important;font-weight: 500;" href="https://eqpays.com/m/${alias}" target="_blank">Ir a local</a>
          <br><br>
          `;

          //Direcciona al google maps
          //<a class="btn btn-sm" style="color: #07325b !important;background-color: #ffbd59 !important;border-color: #ffbd59 !important;font-weight: 500;" href="https://www.google.es/maps?q=${latitud},${longitud}" target="_blank">Ir a local</a>

        this.infoWindow.infoWindow.setContent(
          infoWindowContent
        )

        this.infoWindow.open(marker);
      } else {
        this.photoCenter = data['negocios'][0]['photo']; //data['photo'];
      }
    }, err => {
      console.log(err)
    })
  }

  onKey(event: any) {
    this.values = event.target.value;
    if (this.values.length >= 3) {
      console.log(this.markers);
      this.searchActive = true;
    } else {
      this.searchActive = null;
    }

  }

  onClick(item) {
    //console.log(item);
    this.center = item.position;
    this.term = '';
    this.searchActive = null;

  }
}
